{
  "address": "11111111111111111111111111111111",
  "metadata": {
    "name": "mastermind",
    "version": "0.1.0",
    "spec": "0.1.0",
    "description": "Created with Anchor"
  },
  "instructions": [
    {
      "name": "become_authority",
      "discriminator": [25, 249, 222, 93, 121, 106, 104, 46],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "pending_authority",
          "writable": true,
          "signer": true,
          "relations": ["state"]
        }
      ],
      "args": []
    },
    {
      "name": "buy_exact_in",
      "discriminator": [250, 234, 13, 123, 213, 156, 19, 236],
      "accounts": [
        {
          "name": "state",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "mint"
        },
        {
          "name": "bonding_curve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ]
          }
        },
        {
          "name": "bonding_curve_sol_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              },
              {
                "kind": "const",
                "value": [95, 115, 111, 108, 95, 118, 97, 117, 108, 116]
              }
            ]
          }
        },
        {
          "name": "bonding_curve_token_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "bonding_curve"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "receiver_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "receiver"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "receiver",
          "docs": [
            "@dev: if receiver == payer: repeated accounts don't add to the size of the transaction due to how Solana serializes accounts in transactions."
          ]
        },
        {
          "name": "fee_receiver",
          "writable": true
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "bumps",
          "type": {
            "defined": {
              "name": "InstructionBumps"
            }
          }
        },
        {
          "name": "sol_amount_input",
          "type": "u64"
        },
        {
          "name": "min_tokens_output",
          "type": "u64"
        }
      ]
    },
    {
      "name": "buy_exact_out",
      "discriminator": [24, 211, 116, 40, 105, 3, 153, 56],
      "accounts": [
        {
          "name": "state",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "mint"
        },
        {
          "name": "bonding_curve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ]
          }
        },
        {
          "name": "bonding_curve_sol_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              },
              {
                "kind": "const",
                "value": [95, 115, 111, 108, 95, 118, 97, 117, 108, 116]
              }
            ]
          }
        },
        {
          "name": "bonding_curve_token_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "bonding_curve"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "receiver_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "receiver"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "receiver",
          "docs": [
            "@dev: if receiver == payer: repeated accounts don't add to the size of the transaction due to how Solana serializes accounts in transactions."
          ]
        },
        {
          "name": "fee_receiver",
          "writable": true
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "bumps",
          "type": {
            "defined": {
              "name": "InstructionBumps"
            }
          }
        },
        {
          "name": "max_sol_amount_input",
          "type": "u64"
        },
        {
          "name": "tokens_output",
          "type": "u64"
        }
      ]
    },
    {
      "name": "buy_max_out",
      "discriminator": [96, 177, 203, 117, 183, 65, 196, 177],
      "accounts": [
        {
          "name": "state",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "mint"
        },
        {
          "name": "bonding_curve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ]
          }
        },
        {
          "name": "bonding_curve_sol_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              },
              {
                "kind": "const",
                "value": [95, 115, 111, 108, 95, 118, 97, 117, 108, 116]
              }
            ]
          }
        },
        {
          "name": "bonding_curve_token_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "bonding_curve"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "receiver_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "receiver"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "receiver",
          "docs": [
            "@dev: if receiver == payer: repeated accounts don't add to the size of the transaction due to how Solana serializes accounts in transactions."
          ]
        },
        {
          "name": "fee_receiver",
          "writable": true
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "bumps",
          "type": {
            "defined": {
              "name": "InstructionBumps"
            }
          }
        },
        {
          "name": "max_sol_amount_input",
          "type": "u64"
        },
        {
          "name": "min_tokens_output",
          "type": "u64"
        }
      ]
    },
    {
      "name": "collect_cp_fees",
      "discriminator": [8, 30, 51, 199, 209, 184, 247, 133],
      "accounts": [
        {
          "name": "state",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "locking_program",
          "address": "LockrWmn6K5twhz3y9w1dQERbmgSaRkfnTeTKbpofwE"
        },
        {
          "name": "authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  108, 111, 99, 107, 95, 99, 112, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121,
                  95, 115, 101, 101, 100
                ]
              }
            ],
            "program": {
              "kind": "account",
              "path": "locking_program"
            }
          }
        },
        {
          "name": "fee_nft_owner",
          "docs": ["Fee nft owner who is allowed to receive fees"],
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  102, 101, 101, 95, 110, 102, 116, 95, 99, 111, 108, 108, 101, 99, 116, 111, 114
                ]
              }
            ]
          }
        },
        {
          "name": "fee_nft_account",
          "docs": ["Fee token account"]
        },
        {
          "name": "locked_liquidity",
          "docs": ["Store the locked the information of liquidity"],
          "writable": true
        },
        {
          "name": "cpmm_program",
          "docs": ["cpmm program"],
          "address": "CPMMoo8L3F4NbTegBCKVNunggL7H1ZpdTHKxQB5qKP1C"
        },
        {
          "name": "cp_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118, 97, 117, 108, 116, 95, 97, 110, 100, 95, 108, 112, 95, 109, 105, 110, 116,
                  95, 97, 117, 116, 104, 95, 115, 101, 101, 100
                ]
              }
            ],
            "program": {
              "kind": "account",
              "path": "cpmm_program"
            }
          }
        },
        {
          "name": "pool_state",
          "writable": true
        },
        {
          "name": "lp_mint",
          "docs": ["The mint of liquidity token", "address = pool_state.lp_mint"],
          "writable": true
        },
        {
          "name": "referral_pool_sol_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [114, 101, 102, 101, 114, 114, 97, 108, 45, 112, 111, 111, 108]
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0
              ]
            }
          }
        },
        {
          "name": "wrapper_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "wrapper_state",
          "writable": true
        },
        {
          "name": "wrapper_mint",
          "writable": true
        },
        {
          "name": "recipient_token_0_account",
          "docs": ["The token account for receive token_0"],
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "fee_nft_owner"
              },
              {
                "kind": "account",
                "path": "token_0_program"
              },
              {
                "kind": "account",
                "path": "vault_0_mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "recipient_token_1_account",
          "docs": ["The token account for receive token_1"],
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "fee_nft_owner"
              },
              {
                "kind": "account",
                "path": "token_1_program"
              },
              {
                "kind": "account",
                "path": "vault_1_mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "token_0_vault",
          "docs": [
            "The address that holds pool tokens for token_0",
            "address = pool_state.token_0_vault"
          ],
          "writable": true
        },
        {
          "name": "token_1_vault",
          "docs": [
            "The address that holds pool tokens for token_1",
            "address = pool_state.token_1_vault"
          ],
          "writable": true
        },
        {
          "name": "vault_0_mint",
          "docs": ["The mint of token_0 vault"],
          "writable": true
        },
        {
          "name": "vault_1_mint",
          "docs": ["The mint of token_1 vault"],
          "writable": true
        },
        {
          "name": "locked_lp_vault",
          "docs": ["locked lp token account"],
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "authority"
              },
              {
                "kind": "const",
                "value": [
                  6, 221, 246, 225, 215, 101, 161, 147, 217, 203, 225, 70, 206, 235, 121, 172, 28,
                  180, 133, 237, 95, 91, 55, 145, 58, 140, 245, 133, 126, 255, 0, 169
                ]
              },
              {
                "kind": "account",
                "path": "lp_mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "token_0_program"
        },
        {
          "name": "token_1_program"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "token_program_2022",
          "address": "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb"
        },
        {
          "name": "memo_program",
          "docs": ["memo program"],
          "address": "MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr"
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "fee_nft_owner_bump",
          "type": "u8"
        }
      ]
    },
    {
      "name": "create",
      "discriminator": [24, 30, 200, 40, 5, 28, 7, 119],
      "accounts": [
        {
          "name": "state",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "bonding_curve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ]
          }
        },
        {
          "name": "mint"
        },
        {
          "name": "bonding_curve_sol_vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              },
              {
                "kind": "const",
                "value": [95, 115, 111, 108, 95, 118, 97, 117, 108, 116]
              }
            ]
          }
        },
        {
          "name": "bonding_curve_token_associated_account",
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "bonding_curve"
              },
              {
                "kind": "account",
                "path": "token_program_2022"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "token_program_2022",
          "address": "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "name",
          "type": "string"
        },
        {
          "name": "symbol",
          "type": "string"
        },
        {
          "name": "uri",
          "type": "string"
        },
        {
          "name": "migration_kind",
          "type": {
            "defined": {
              "name": "MigrationKind"
            }
          }
        }
      ]
    },
    {
      "name": "initialize",
      "discriminator": [175, 175, 109, 31, 13, 152, 155, 237],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "migrator",
          "type": "pubkey"
        },
        {
          "name": "wrapper_mint",
          "type": "pubkey"
        },
        {
          "name": "fee_receiver",
          "type": "pubkey"
        },
        {
          "name": "fee_bps",
          "type": "u64"
        },
        {
          "name": "initial_virtual_token_reserve",
          "type": "u64"
        },
        {
          "name": "initial_virtual_sol_reserve",
          "type": "u64"
        },
        {
          "name": "coin_lot_size",
          "type": "u64"
        },
        {
          "name": "pc_lot_size",
          "type": "u64"
        }
      ]
    },
    {
      "name": "migrate_to_radium",
      "discriminator": [96, 230, 91, 140, 139, 40, 235, 142],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "token_mint",
          "writable": true
        },
        {
          "name": "wrapper_mint",
          "writable": true
        },
        {
          "name": "bonding_curve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "token_mint"
              }
            ]
          }
        },
        {
          "name": "bonding_curve_wrapper_associated_account",
          "writable": true
        },
        {
          "name": "bonding_curve_token_associated_account",
          "writable": true
        },
        {
          "name": "wrapper_program"
        },
        {
          "name": "wrapper_state",
          "writable": true
        },
        {
          "name": "wrapper_mint_authority"
        },
        {
          "name": "payer_wrapper_associated_account",
          "writable": true
        },
        {
          "name": "payer_token_associated_account",
          "writable": true
        },
        {
          "name": "cp_swap_program",
          "address": "CPMMoo8L3F4NbTegBCKVNunggL7H1ZpdTHKxQB5qKP1C"
        },
        {
          "name": "creator",
          "docs": ["Address paying to create the pool. Can be anyone"],
          "writable": true,
          "signer": true
        },
        {
          "name": "amm_config",
          "docs": ["Which config the pool belongs to."]
        },
        {
          "name": "authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118, 97, 117, 108, 116, 95, 97, 110, 100, 95, 108, 112, 95, 109, 105, 110, 116,
                  95, 97, 117, 116, 104, 95, 115, 101, 101, 100
                ]
              }
            ],
            "program": {
              "kind": "account",
              "path": "cp_swap_program"
            }
          }
        },
        {
          "name": "pool_state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [112, 111, 111, 108]
              },
              {
                "kind": "account",
                "path": "amm_config"
              },
              {
                "kind": "account",
                "path": "token_0_mint"
              },
              {
                "kind": "account",
                "path": "token_1_mint"
              }
            ],
            "program": {
              "kind": "account",
              "path": "cp_swap_program"
            }
          }
        },
        {
          "name": "token_0_mint",
          "docs": ["Token_0 mint, the key must smaller then token_1 mint."]
        },
        {
          "name": "token_1_mint",
          "docs": ["Token_1 mint, the key must grater then token_0 mint."]
        },
        {
          "name": "lp_mint",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [112, 111, 111, 108, 95, 108, 112, 95, 109, 105, 110, 116]
              },
              {
                "kind": "account",
                "path": "pool_state"
              }
            ],
            "program": {
              "kind": "account",
              "path": "cp_swap_program"
            }
          }
        },
        {
          "name": "creator_token_0",
          "docs": ["payer token0 account"],
          "writable": true
        },
        {
          "name": "creator_token_1",
          "docs": ["creator token1 account"],
          "writable": true
        },
        {
          "name": "creator_lp_token",
          "writable": true
        },
        {
          "name": "token_0_vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [112, 111, 111, 108, 95, 118, 97, 117, 108, 116]
              },
              {
                "kind": "account",
                "path": "pool_state"
              },
              {
                "kind": "account",
                "path": "token_0_mint"
              }
            ],
            "program": {
              "kind": "account",
              "path": "cp_swap_program"
            }
          }
        },
        {
          "name": "token_1_vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [112, 111, 111, 108, 95, 118, 97, 117, 108, 116]
              },
              {
                "kind": "account",
                "path": "pool_state"
              },
              {
                "kind": "account",
                "path": "token_1_mint"
              }
            ],
            "program": {
              "kind": "account",
              "path": "cp_swap_program"
            }
          }
        },
        {
          "name": "create_pool_fee",
          "docs": ["create pool fee account"],
          "writable": true,
          "address": "DNXgeM9EiiaAbaWvwjHj9fQQLAX5ZsfHyvmYUNRAdNC8"
        },
        {
          "name": "observation_state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [111, 98, 115, 101, 114, 118, 97, 116, 105, 111, 110]
              },
              {
                "kind": "account",
                "path": "pool_state"
              }
            ],
            "program": {
              "kind": "account",
              "path": "cp_swap_program"
            }
          }
        },
        {
          "name": "locking_program",
          "address": "LockrWmn6K5twhz3y9w1dQERbmgSaRkfnTeTKbpofwE"
        },
        {
          "name": "locking_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  108, 111, 99, 107, 95, 99, 112, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121,
                  95, 115, 101, 101, 100
                ]
              }
            ],
            "program": {
              "kind": "account",
              "path": "locking_program"
            }
          }
        },
        {
          "name": "fee_nft_owner",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  102, 101, 101, 95, 110, 102, 116, 95, 99, 111, 108, 108, 101, 99, 116, 111, 114
                ]
              }
            ]
          }
        },
        {
          "name": "fee_nft_mint",
          "writable": true,
          "signer": true
        },
        {
          "name": "fee_nft_account",
          "writable": true
        },
        {
          "name": "locked_liquidity",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  108, 111, 99, 107, 101, 100, 95, 108, 105, 113, 117, 105, 100, 105, 116, 121
                ]
              },
              {
                "kind": "account",
                "path": "fee_nft_mint"
              }
            ],
            "program": {
              "kind": "account",
              "path": "locking_program"
            }
          }
        },
        {
          "name": "locked_lp_vault",
          "writable": true
        },
        {
          "name": "metadata_account",
          "docs": ["To store metaplex metadata"],
          "writable": true
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "token_program_2022",
          "address": "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb"
        },
        {
          "name": "token_0_program"
        },
        {
          "name": "token_1_program"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "metadata_program",
          "address": "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": []
    },
    {
      "name": "sell_exact_in",
      "discriminator": [149, 39, 222, 155, 211, 124, 152, 26],
      "accounts": [
        {
          "name": "state",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "mint"
        },
        {
          "name": "bonding_curve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ]
          }
        },
        {
          "name": "bonding_curve_sol_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              },
              {
                "kind": "const",
                "value": [95, 115, 111, 108, 95, 118, 97, 117, 108, 116]
              }
            ]
          }
        },
        {
          "name": "bonding_curve_token_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "bonding_curve"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "payer"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "receiver",
          "docs": [
            "@dev: if receiver == payer: repeated accounts don't add to the size of the transaction due to how Solana serializes accounts in transactions."
          ],
          "writable": true
        },
        {
          "name": "fee_receiver",
          "writable": true
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "bumps",
          "type": {
            "defined": {
              "name": "InstructionBumps"
            }
          }
        },
        {
          "name": "tokens_input",
          "type": "u64"
        },
        {
          "name": "min_sol_amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "sell_exact_out",
      "discriminator": [95, 200, 71, 34, 8, 9, 11, 166],
      "accounts": [
        {
          "name": "state",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "mint"
        },
        {
          "name": "bonding_curve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ]
          }
        },
        {
          "name": "bonding_curve_sol_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "mint"
              },
              {
                "kind": "const",
                "value": [95, 115, 111, 108, 95, 118, 97, 117, 108, 116]
              }
            ]
          }
        },
        {
          "name": "bonding_curve_token_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "bonding_curve"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer_associated_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "payer"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "receiver",
          "docs": [
            "@dev: if receiver == payer: repeated accounts don't add to the size of the transaction due to how Solana serializes accounts in transactions."
          ],
          "writable": true
        },
        {
          "name": "fee_receiver",
          "writable": true
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": [
        {
          "name": "bumps",
          "type": {
            "defined": {
              "name": "InstructionBumps"
            }
          }
        },
        {
          "name": "max_tokens_input",
          "type": "u64"
        },
        {
          "name": "sol_amount_output",
          "type": "u64"
        }
      ]
    },
    {
      "name": "set_curve_params",
      "discriminator": [133, 183, 61, 96, 198, 233, 62, 13],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": ["state"]
        }
      ],
      "args": [
        {
          "name": "initial_virtual_token_reserve",
          "type": "u64"
        },
        {
          "name": "initial_virtual_sol_reserve",
          "type": "u64"
        }
      ]
    },
    {
      "name": "set_fee_bps",
      "discriminator": [2, 161, 245, 141, 111, 32, 39, 198],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": ["state"]
        }
      ],
      "args": [
        {
          "name": "fee_bps",
          "type": "u64"
        }
      ]
    },
    {
      "name": "set_fee_receiver",
      "discriminator": [222, 168, 176, 101, 242, 87, 191, 16],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": ["state"]
        }
      ],
      "args": [
        {
          "name": "fee_receiver",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "set_migration_lot_size",
      "discriminator": [224, 245, 51, 3, 173, 186, 250, 230],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": ["state"]
        }
      ],
      "args": [
        {
          "name": "coin_lot_size",
          "type": "u64"
        },
        {
          "name": "pc_lot_size",
          "type": "u64"
        }
      ]
    },
    {
      "name": "set_migration_refund",
      "discriminator": [148, 239, 194, 248, 85, 104, 213, 52],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": ["state"]
        }
      ],
      "args": [
        {
          "name": "migration_refund",
          "type": "u64"
        }
      ]
    },
    {
      "name": "set_migrator",
      "discriminator": [209, 164, 101, 138, 178, 62, 195, 249],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": ["state"]
        }
      ],
      "args": [
        {
          "name": "migrator",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "set_pending_authority",
      "discriminator": [175, 71, 167, 223, 49, 144, 102, 193],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": ["state"]
        }
      ],
      "args": [
        {
          "name": "pending_authority",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "set_wrapper_mint",
      "discriminator": [65, 169, 74, 24, 18, 148, 174, 154],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "authority",
          "writable": true,
          "signer": true,
          "relations": ["state"]
        }
      ],
      "args": [
        {
          "name": "wrapper_mint",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "sync_wrapper",
      "discriminator": [58, 56, 206, 153, 224, 221, 169, 86],
      "accounts": [
        {
          "name": "state",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "wrapper_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "wrapper_state",
          "writable": true
        },
        {
          "name": "wrapper_mint",
          "writable": true
        },
        {
          "name": "wrapper_mint_authority"
        },
        {
          "name": "fee_receiver_token_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "fee_receiver"
              },
              {
                "kind": "const",
                "value": [
                  6, 221, 246, 225, 215, 101, 161, 147, 217, 203, 225, 70, 206, 235, 121, 172, 28,
                  180, 133, 237, 95, 91, 55, 145, 58, 140, 245, 133, 126, 255, 0, 169
                ]
              },
              {
                "kind": "account",
                "path": "wrapper_mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "fee_receiver",
          "writable": true
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": []
    },
    {
      "name": "wrap_sol_for_curve",
      "discriminator": [32, 147, 121, 169, 176, 40, 51, 95],
      "accounts": [
        {
          "name": "state",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [115, 116, 97, 116, 101]
              }
            ]
          }
        },
        {
          "name": "token_mint",
          "writable": true
        },
        {
          "name": "bonding_curve",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "token_mint"
              }
            ]
          }
        },
        {
          "name": "bonding_curve_sol_vault",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [98, 111, 110, 100, 105, 110, 103, 95, 99, 117, 114, 118, 101, 95]
              },
              {
                "kind": "account",
                "path": "token_mint"
              },
              {
                "kind": "const",
                "value": [95, 115, 111, 108, 95, 118, 97, 117, 108, 116]
              }
            ]
          }
        },
        {
          "name": "wrapper_program"
        },
        {
          "name": "wrapper_state",
          "writable": true
        },
        {
          "name": "wrapper_mint",
          "writable": true
        },
        {
          "name": "wrapper_mint_authority"
        },
        {
          "name": "wrapper_bonding_curve_token_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "bonding_curve"
              },
              {
                "kind": "const",
                "value": [
                  6, 221, 246, 225, 215, 101, 161, 147, 217, 203, 225, 70, 206, 235, 121, 172, 28,
                  180, 133, 237, 95, 91, 55, 145, 58, 140, 245, 133, 126, 255, 0, 169
                ]
              },
              {
                "kind": "account",
                "path": "wrapper_mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142, 13, 131, 11, 90, 19,
                153, 218, 255, 16, 132, 4, 142, 123, 216, 219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "event_authority",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  95, 95, 101, 118, 101, 110, 116, 95, 97, 117, 116, 104, 111, 114, 105, 116, 121
                ]
              }
            ]
          }
        },
        {
          "name": "program"
        }
      ],
      "args": []
    }
  ],
  "accounts": [
    {
      "name": "AmmConfig",
      "discriminator": [218, 244, 33, 104, 203, 203, 43, 111]
    },
    {
      "name": "Curve",
      "discriminator": [191, 180, 249, 66, 180, 71, 51, 182]
    },
    {
      "name": "LockedCpLiquidityState",
      "discriminator": [25, 10, 238, 197, 207, 234, 73, 22]
    },
    {
      "name": "State",
      "discriminator": [216, 146, 107, 94, 104, 75, 182, 177]
    }
  ],
  "events": [
    {
      "name": "AuthorityChangedEvent",
      "discriminator": [85, 105, 159, 188, 6, 44, 52, 28]
    },
    {
      "name": "CollectEvent",
      "discriminator": [138, 16, 76, 55, 167, 75, 242, 47]
    },
    {
      "name": "CompleteEvent",
      "discriminator": [95, 114, 97, 156, 212, 46, 152, 8]
    },
    {
      "name": "CreateEvent",
      "discriminator": [27, 114, 169, 77, 222, 235, 99, 118]
    },
    {
      "name": "MigrateEvent",
      "discriminator": [216, 175, 231, 95, 45, 98, 108, 21]
    },
    {
      "name": "SetParamsEvent",
      "discriminator": [223, 195, 159, 246, 62, 48, 143, 131]
    },
    {
      "name": "SetPendingAuthorityEvent",
      "discriminator": [37, 79, 147, 25, 141, 199, 111, 161]
    },
    {
      "name": "TradeEvent",
      "discriminator": [189, 219, 127, 211, 78, 230, 97, 238]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "Unauthorized",
      "msg": "Unauthorized: Incorrect signer or program ID"
    },
    {
      "code": 6001,
      "name": "StateNotInitialized",
      "msg": "State not initialized"
    },
    {
      "code": 6002,
      "name": "ZeroAuthority",
      "msg": "Initial authority pubkey cannot be zero"
    },
    {
      "code": 6003,
      "name": "ZeroPsol",
      "msg": "Initial pSOL pubkey cannot be zero"
    },
    {
      "code": 6004,
      "name": "ZeroFeeReceiver",
      "msg": "Initial fee receiver pubkey cannot be zero"
    },
    {
      "code": 6005,
      "name": "InvalidFeeBps",
      "msg": "Invalid fee basis points"
    },
    {
      "code": 6006,
      "name": "InvalidVirtualReserves",
      "msg": "Invalid virtual reserves"
    },
    {
      "code": 6007,
      "name": "InvalidCurveIntialization",
      "msg": "Invalid curve intialization params"
    },
    {
      "code": 6008,
      "name": "CurveNotCompleted",
      "msg": "Curve is not completed"
    },
    {
      "code": 6009,
      "name": "CurveSolNotWrapped",
      "msg": "Curve SOL must be wrapped"
    },
    {
      "code": 6010,
      "name": "CurveAlreadyCompleted",
      "msg": "Curve is completed"
    },
    {
      "code": 6011,
      "name": "CurveTimeLockedOrMigrated",
      "msg": "Curve is time locked or migrated"
    },
    {
      "code": 6012,
      "name": "CurveAlreadyMigrated",
      "msg": "Curve is already migrated"
    },
    {
      "code": 6013,
      "name": "WrongTokenOutput",
      "msg": "Token output exceed limit"
    },
    {
      "code": 6014,
      "name": "InvariantKMismatch",
      "msg": "K"
    },
    {
      "code": 6015,
      "name": "SlippageExceeded",
      "msg": "Slippage exceeded"
    }
  ],
  "types": [
    {
      "name": "AmmConfig",
      "docs": ["Holds the current owner of the factory"],
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "docs": ["Bump to identify PDA"],
            "type": "u8"
          },
          {
            "name": "disable_create_pool",
            "docs": ["Status to control if new pool can be create"],
            "type": "bool"
          },
          {
            "name": "index",
            "docs": ["Config index"],
            "type": "u16"
          },
          {
            "name": "trade_fee_rate",
            "docs": ["The trade fee, denominated in hundredths of a bip (10^-6)"],
            "type": "u64"
          },
          {
            "name": "protocol_fee_rate",
            "docs": ["The protocol fee"],
            "type": "u64"
          },
          {
            "name": "fund_fee_rate",
            "docs": ["The fund fee, denominated in hundredths of a bip (10^-6)"],
            "type": "u64"
          },
          {
            "name": "create_pool_fee",
            "docs": ["Fee for create a new pool"],
            "type": "u64"
          },
          {
            "name": "protocol_owner",
            "docs": ["Address of the protocol fee owner"],
            "type": "pubkey"
          },
          {
            "name": "fund_owner",
            "docs": ["Address of the fund fee owner"],
            "type": "pubkey"
          },
          {
            "name": "padding",
            "docs": ["padding"],
            "type": {
              "array": ["u64", 16]
            }
          }
        ]
      }
    },
    {
      "name": "AuthorityChangedEvent",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "old_authority",
            "type": "pubkey"
          },
          {
            "name": "new_authority",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "CollectEvent",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "mint",
            "type": "pubkey"
          },
          {
            "name": "amount",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "CompleteEvent",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "user",
            "type": "pubkey"
          },
          {
            "name": "mint",
            "type": "pubkey"
          },
          {
            "name": "bonding_curve",
            "type": "pubkey"
          },
          {
            "name": "timestamp",
            "type": "i64"
          }
        ]
      }
    },
    {
      "name": "CreateEvent",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "name",
            "type": "string"
          },
          {
            "name": "symbol",
            "type": "string"
          },
          {
            "name": "uri",
            "type": "string"
          },
          {
            "name": "mint",
            "type": "pubkey"
          },
          {
            "name": "bonding_curve",
            "type": "pubkey"
          },
          {
            "name": "user",
            "type": "pubkey"
          },
          {
            "name": "migration_kind",
            "type": {
              "defined": {
                "name": "MigrationKind"
              }
            }
          }
        ]
      }
    },
    {
      "name": "Curve",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "version",
            "type": "u8"
          },
          {
            "name": "data",
            "type": {
              "defined": {
                "name": "CurveDataV1"
              }
            }
          }
        ]
      }
    },
    {
      "name": "CurveDataV1",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "completed",
            "type": "i64"
          },
          {
            "name": "real_token_reserve",
            "type": "u64"
          },
          {
            "name": "real_sol_reserve",
            "type": "u64"
          },
          {
            "name": "virtual_token_reserve",
            "type": "u64"
          },
          {
            "name": "virtual_sol_reserve",
            "type": "u64"
          },
          {
            "name": "migration_kind",
            "type": {
              "defined": {
                "name": "MigrationKind"
              }
            }
          }
        ]
      }
    },
    {
      "name": "InstructionBumps",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bonding_curve",
            "type": "u8"
          },
          {
            "name": "bonding_curve_sol_associated_account",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "LockedCpLiquidityState",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "locked_lp_amount",
            "docs": ["The Locked liquidity amount without claimed lp fee"],
            "type": "u64"
          },
          {
            "name": "claimed_lp_amount",
            "docs": ["Claimed lp fee amount"],
            "type": "u64"
          },
          {
            "name": "unclaimed_lp_amount",
            "docs": ["Unclaimed lp fee amount"],
            "type": "u64"
          },
          {
            "name": "last_lp",
            "docs": ["Last updated cp pool lp total supply"],
            "type": "u64"
          },
          {
            "name": "last_k",
            "docs": ["Last updated cp pool k"],
            "type": "u128"
          },
          {
            "name": "recent_epoch",
            "docs": ["Account update recent epoch"],
            "type": "u64"
          },
          {
            "name": "pool_id",
            "docs": ["The ID of the pool with which this record is connected"],
            "type": "pubkey"
          },
          {
            "name": "fee_nft_mint",
            "docs": ["nft mint to check who has authority to collect fee"],
            "type": "pubkey"
          },
          {
            "name": "locked_owner",
            "docs": ["The owner who has locked liquidity"],
            "type": "pubkey"
          },
          {
            "name": "locked_lp_mint",
            "docs": ["The mint of locked lp token"],
            "type": "pubkey"
          },
          {
            "name": "padding",
            "docs": ["Unused bytes for future upgrades."],
            "type": {
              "array": ["u64", 8]
            }
          }
        ]
      }
    },
    {
      "name": "MigrateEvent",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "token_mint",
            "type": "pubkey"
          },
          {
            "name": "pool_address",
            "type": "pubkey"
          },
          {
            "name": "vault_a",
            "type": "pubkey"
          },
          {
            "name": "vault_b",
            "type": "pubkey"
          },
          {
            "name": "timestamp",
            "type": "i64"
          }
        ]
      }
    },
    {
      "name": "MigrationKind",
      "repr": {
        "kind": "rust"
      },
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "PSol"
          },
          {
            "name": "WSol"
          }
        ]
      }
    },
    {
      "name": "SetParamsEvent",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "fee_receiver",
            "type": "pubkey"
          },
          {
            "name": "fee_bps",
            "type": "u64"
          },
          {
            "name": "initial_virtual_token_reserve",
            "type": "u64"
          },
          {
            "name": "initial_virtual_sol_reserve",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "SetPendingAuthorityEvent",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "pending_authority",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "State",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "version",
            "type": "u8"
          },
          {
            "name": "data",
            "type": {
              "defined": {
                "name": "StateDataV1"
              }
            }
          }
        ]
      }
    },
    {
      "name": "StateDataV1",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "initialized",
            "type": "bool"
          },
          {
            "name": "authority",
            "type": "pubkey"
          },
          {
            "name": "pending_authority",
            "type": "pubkey"
          },
          {
            "name": "wrapper_mint",
            "type": "pubkey"
          },
          {
            "name": "fee_receiver",
            "type": "pubkey"
          },
          {
            "name": "fee_bps",
            "type": "u64"
          },
          {
            "name": "initial_virtual_token_reserve",
            "type": "u64"
          },
          {
            "name": "initial_virtual_sol_reserve",
            "type": "u64"
          },
          {
            "name": "coin_lot_size",
            "type": "u64"
          },
          {
            "name": "pc_lot_size",
            "type": "u64"
          },
          {
            "name": "solvent_wrapper",
            "type": "u64"
          },
          {
            "name": "migrator",
            "type": "pubkey"
          },
          {
            "name": "migration_count",
            "type": "u64"
          },
          {
            "name": "migration_refund",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "TradeEvent",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "mint",
            "type": "pubkey"
          },
          {
            "name": "sol_amount",
            "type": "u64"
          },
          {
            "name": "token_amount",
            "type": "u64"
          },
          {
            "name": "is_buy",
            "type": "bool"
          },
          {
            "name": "user",
            "type": "pubkey"
          },
          {
            "name": "timestamp",
            "type": "i64"
          },
          {
            "name": "real_sol_reserves",
            "type": "u64"
          },
          {
            "name": "virtual_sol_reserves",
            "type": "u64"
          },
          {
            "name": "real_token_reserves",
            "type": "u64"
          },
          {
            "name": "virtual_token_reserves",
            "type": "u64"
          }
        ]
      }
    }
  ]
}
